import { createSelector } from 'reselect';

const cartData = (state) => state.cartDetails || {};
const validateOrder = (cartDetails) => cartDetails?.validateOrder || {};

const selectData = createSelector(cartData, (data) => {
  const modifiedData = `${data.title  }from Selector`;
  return modifiedData;
});

const getCreditHoldStatus = createSelector(validateOrder, (data) => {
  const creditHoldStatus = data && data.orderDetails && data.orderDetails[0] && data.orderDetails[0].creditApprovalStatus && data.orderDetails[0].creditApprovalStatus !== 'AP' ? true : undefined;
  return creditHoldStatus;
});

const getCreditHoldResponse = createSelector(validateOrder, (data) => {
  const creditHoldResponse = data?.orderDetails?.[0]?.creditHoldContent || undefined;
  return creditHoldResponse;
});

const getValidateOrder = createSelector(validateOrder);

export {
  selectData,
  getCreditHoldStatus,
  getCreditHoldResponse,
  getValidateOrder,
};
